import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Grid, TextCharLimit, Button, Typography, SwitchCheckbox} from 'views/components';
import {translate, Translate} from 'views/module';

const Content = (props) => {
  const [questionTitle, setQuestionTitle] = React.useState('');
  const [questionOptions, setQuestionOptions] = React.useState([]);
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);

  const careviewItem = props.careviewItem;
  const setViewMode = props.setViewMode;
  const updateQuestion = props.updateQuestion;

  React.useEffect(() => {
    setQuestionTitle(careviewItem.questionData.questionTitle);
    setQuestionOptions(careviewItem.questionData.options || []);
  }, [careviewItem]);

  // Update the save button's disabled state
  React.useEffect(() => {
    const options = questionOptions
        .filter((e) => e.optionTitle.trim().length);
    setIsSaveDisabled(!(questionTitle.trim().length && options.length >= 2));
  }, [questionTitle, questionOptions]);

  const onSave = () => {
    setIsSaving(true);
    const options = questionOptions
        .filter((e) => e.optionTitle.trim().length)
        .map((e) => {
          if (e.followUp === undefined) {
            e.followUp = false;
          }
          return e;
        });
    const updatedCareviewItem = {
      ...careviewItem.questionData,
      questionTitle: questionTitle,
      options,
    };

    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateQuestion(updatedCareviewItem, onSuccess);
  };
  const addNewOption = () => {
    setQuestionOptions((questionOptions) => [...questionOptions, {optionTitle: '', followUp: false}]);
  };
  const updateOptionTitle = (index, optionTitle) => {
    setQuestionOptions((questionOptions) => {
      const newOptions = [...questionOptions];
      newOptions[index] = {...newOptions[index], optionTitle};
      return newOptions;
    });
  };
  const updateOptionFollowup = (index, followUp) => {
    setQuestionOptions((questionOptions) => {
      const newOptions = [...questionOptions];
      newOptions[index] = {...newOptions[index], followUp};
      return newOptions;
    });
  };

  return (
    <Box>
      <Stack
        spacing={1}
      >
        <TextCharLimit
          label={translate('client.ClientDetail.CareviewSettings.Types.MultipleChoice.Question')}
          placeholder={translate('client.ClientDetail.CareviewSettings.Types.MultipleChoice.Question')}
          value={questionTitle}
          onChange={setQuestionTitle}
          charLimit={180}
          autoFocus
          fullWidth
        />
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '18px',
          }}
        >
          <Translate
            expression='client.ClientDetail.CareviewSettings.Types.MultipleChoice.Options'
          />
        </Typography>
        {
          questionOptions.map((option, index) => {
            return (
              <Grid
                key={index}
                container

              >
                <Grid item xs={8}>
                  <TextCharLimit
                    label={translate('client.ClientDetail.CareviewSettings.Types.MultipleChoice.OptionNumber', {number: index + 1})}
                    placeholder={translate('client.ClientDetail.CareviewSettings.Types.MultipleChoice.OptionNumber', {number: index + 1})}
                    value={option.optionTitle}
                    onChange={(e) => updateOptionTitle(index, e)}
                    charLimit={180}
                    autoFocus
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4}>
                  <SwitchCheckbox
                    label={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Followup')}
                    value={option.followUp || false}
                    onChange={(e) => updateOptionFollowup(index, e)}
                  />
                </Grid>
              </Grid>
            );
          })
        }
        <Box>
          <Button
            onClick={addNewOption}
            fullWidth={false}
          >
            <Translate expression='client.ClientDetail.CareviewSettings.Types.MultipleChoice.AddNew' />
          </Button>
        </Box>
      </Stack>
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='client.ClientDetail.CareviewSettings.Types.Actions.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
          disabled={isSaveDisabled}
        >
          <Translate expression='client.ClientDetail.CareviewSettings.Types.Actions.Save' />
        </Button>
      </Stack>
    </Box>
  );
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  updateQuestion: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
